export type PaginationSearchParams = {
  limit?: number;
  offset?: number;
};

export const ORDER_BY_DIR_SEARCH_PARAM = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type OrderByDirSearchParamName = keyof typeof ORDER_BY_DIR_SEARCH_PARAM;

export type OrderByDirSearchParam = (typeof ORDER_BY_DIR_SEARCH_PARAM)[OrderByDirSearchParamName];
